import {
  ReportStatus,
  IN_FLIGHT_STATUSES,
  IN_FLIGHT_PRELIM_STATUSES,
  PROVISIONAL_SUBMIT_STATUSES,
  ADDENDUM_STATUSES,
} from '../state';
import type { ReportStatuses } from '../state';

/**
 * Pure predicates over report status. These consolidate the status-set membership checks that were
 * previously written inline in Fields.Context, without changing which statuses each check covers.
 */

// A template must not be inserted while any submit/cancel/provisional action is in flight.
const TEMPLATE_INSERTION_FORBIDDEN_STATUSES: ReportStatuses[] = [
  ...IN_FLIGHT_STATUSES,
  ...IN_FLIGHT_PRELIM_STATUSES,
  ...PROVISIONAL_SUBMIT_STATUSES,
];

export const isTemplateInsertionForbidden = (status: ReportStatuses): boolean =>
  TEMPLATE_INSERTION_FORBIDDEN_STATUSES.includes(status);

// Statuses that represent an addendum lifecycle (used to decide which content drives heading errors).
export const isAddendumStatus = (status: ReportStatuses): boolean =>
  (ADDENDUM_STATUSES as unknown as ReportStatuses[]).includes(status);

/**
 * Statuses in which a signing/submission action is already in progress, so a newly-triggered
 * submit must be ignored. Note this intentionally excludes the *cancelling* statuses — it is a
 * strict subset of the in-flight sets and is therefore defined explicitly rather than composed.
 */
const SUBMISSION_IN_FLIGHT_STATUSES: ReportStatuses[] = [
  ReportStatus.Submitting,
  ReportStatus.ProvisionalSubmit,
  ReportStatus.SubmittingPrelim,
  ReportStatus.ProvisionalPrelimSubmit,
  ReportStatus.AddendumSubmitting,
  ReportStatus.ProvisionalAddendumSubmit,
];

export const isSubmissionInFlight = (status: ReportStatuses): boolean =>
  SUBMISSION_IN_FLIGHT_STATUSES.includes(status);
